// extracted by mini-css-extract-plugin
export var createdDate = "_it-1";
export var divider = "_it-2";
export var headerDivider = "_it-3";
export var messagesCard = "_it-0";
export var messagesContainer = "_it-6";
export var messagesContainerWrapper = "_it-4";
export var showLeftPanelButton = "_it-8";
export var topButtons = "_it-7";
export var withPadding = "_it-5";